import { gql } from '@apollo/client';
import { AccountType } from 'graphql/types/AccountType';

export const GET_HUB_DSP_MANAGERS = gql`
    query GetHubDspManagers($hubId: Long!) {
        getHubDspManagers(hubId: $hubId) {
            id
            name
            countryCode
            phone
            email
            status
            role {
                name
            }
            createdAt
            updatedAt
        }
    }
`;

export interface GetHubDspManagersResponse {
    getHubDspManagers: AccountType[];
}

export interface GetHubDspManagersVariables {
    hubId: number;
}

